<script setup>
import { ref, computed, onMounted } from 'vue'
import TickIcon from '@/icons/TickIcon.vue'
import { RefreshIcon } from "@heroicons/vue/outline"
import { usePaymentsStore } from '@/Stores/payments'
const payments = usePaymentsStore()

const props = defineProps({
	card: {
		type: Object,
		default: () => ({
			maskedCardNumber: 'XXXX-XXXX-XXXX-1234',
			expiryDateMonth: '01',
			expiryDateYear: '2022',
			cardType: 'visa',
		})
	},
	selected: {
		type: Boolean,
		default: false
	}
})

const cardType = computed(() => {
	return ['visa', 'mastercard', 'amex'].includes(props.card.cardScheme) ? props.card.cardScheme : 'security-payment';
})
const shown = ref(false)

onMounted(() => {
	setTimeout(() => {
		shown.value = true
	}, 10);
})

</script>

<template>
	<div 
		class="
			saved-card
			flex flex-row items-center space-x-5 content-between
			mb-2 p-3
			shadow-sm
			rounded-md
			bg-white
			border border-gray-200
			hover:shadow-md
			cursor-pointer
		"
		:class="{
			'bg-orange-50 shadow-md': selected,
			'shown': shown
		}"
	>
		<img :src="`/images/credit-card-company-logos/${cardType}.svg`" class="w-8 h-8" />
		<div class="flex flex-col">
			<span class="text-sm font-medium text-gray-900">
				{{ card.maskedCardNumber }}
			</span>
			<span class="text-sm text-gray-500">
				{{ card.expiryDateMonth }}/{{ card.expiryDateYear }}
			</span>
		</div>
		<div
			v-if="card.auto_for"
			class="
				flex flex-row items-center space-x-2 
				text-green-800 text-xs italic
				border border-1 border-green-800 rounded-full 
				bg-green-100
				py-1 px-2
			"
		>
			<RefreshIcon class="fill-blue w-4 h-4 mr-2" /> In use for automatic payments
		</div>
		<div class="flex grow flex-row justify-end">
			<TickIcon v-if="selected" class="fill-green-700 w-6 h-6 mr-4" />
		</div>
	</div>
</template>

<style>
.saved-card {
	opacity: 0;
	transform: translateY(-10px);
	transition: box-shadow 0.15s ease-in-out;
}

.saved-card.shown {
	opacity: 1;
	transform: translateY(0px);
}
</style>